import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField
} from "@material-ui/core";
import { buttonMessages } from "@saleor/intl";
import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

export interface InstagramTagAddDialogProps {
  open: boolean;
  onSubmit: (data: any) => void;
  onClose: () => void;
}

const InstagramTagAddDialog: React.FC<InstagramTagAddDialogProps> = ({
  open,
  onSubmit,
  onClose
}) => {
  const intl = useIntl();
  const [skuSlug, setSkuSlug] = useState<string>("");
  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth="sm">
      <DialogTitle>
        <FormattedMessage
          defaultMessage="Add Tag"
          description="add instagram tag"
        />
      </DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          label={intl.formatMessage({
            defaultMessage: "SKU ID",
            description: "SKU ID"
          })}
          value={skuSlug}
          onChange={event => setSkuSlug(event.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          <FormattedMessage {...buttonMessages.back} />
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={() => onSubmit(skuSlug)}
        >
          <FormattedMessage {...buttonMessages.save} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default InstagramTagAddDialog;
